<div class="flex-div">
  <p>
    <strong>
      Selecione seu método de pagamento
    </strong>
  </p>
  <div>
    <div class="plan-contract-btn mt-2">
      <a class="plan-header-amount" [routerLink]="['/plans', 'pix']">PIX</a>
    </div>
    <div class="plan-contract-btn mt-2">
      <a class="plan-header-amount" [routerLink]="['/plans', 'card']">CRÉDITO</a>
    </div>
  </div>
</div>
